import Image from "next/image";
import { IArticleImageProps } from './interfaces';
import Link from 'next/link';
import { Routes } from '../../../models/enums/routes';
import { imageSerializer } from "../../../utils/imageSerializer";

const ArticleImage = (props: IArticleImageProps) => {
  return (
    <div className={`${props.className}__image`}>
      <Link href={`${Routes.InsightsArticleId}${props.url}`}>
        <Image {...imageSerializer(props.image)}/>
      </Link>
    </div>
  );
};

export default ArticleImage;
